import { render, staticRenderFns } from "./ConnectorKycLayout.vue?vue&type=template&id=a6d9283e&scoped=true"
import script from "./ConnectorKycLayout.vue?vue&type=script&lang=js"
export * from "./ConnectorKycLayout.vue?vue&type=script&lang=js"
import style0 from "./ConnectorKycLayout.vue?vue&type=style&index=0&id=a6d9283e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d9283e",
  null
  
)

export default component.exports